import * as Yup from 'yup';

/**
 * Validation schema for variation form
 */
export const variationValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Variation name is required')
    .max(100, 'Variation name must be less than 100 characters'),
  content: Yup.string()
    .required('Content text is required')
    .max(5000, 'Content text must be less than 5000 characters'),
  version: Yup.number()
    .required('Version is required')
    .min(1, 'Version must be at least 1')
    .integer('Version must be an integer'),
  s3Url: Yup.string()
    .nullable(),
  priority: Yup.string()
    .required('Priority is required')
    .oneOf(['low', 'medium', 'high', 'urgent'], 'Invalid priority'),
  status: Yup.string()
    .required('Status is required')
    .oneOf(['new', 'not-started', 'in-progress', 'review', 'completed'], 'Invalid status'),
  deadline: Yup.date()
    .nullable()
    .transform((curr, orig) => orig === '' ? null : curr)
});

export default {
  variationValidationSchema
};
